/* ============================================================
   SABESS BARBER — comportamenti del tema
   Replica in vanilla JS la logica del progetto React.
   ============================================================ */
(function () {
  "use strict";

  var root = document.documentElement;
  var body = document.body;

  /* ---------- utility ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  function lockScroll() {
    body.classList.toggle("locked", !!($(".fullscreen-menu.open") || $(".cart-panel.open")));
  }

  function formatMoney(cents) {
    var fmt = window.SABESS && window.SABESS.moneyFormat;
    var value = (cents || 0) / 100;
    var str = value.toLocaleString("it-IT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    if (fmt && fmt.indexOf("{{") !== -1) return fmt.replace(/\{\{\s*\w+\s*\}\}/, str);
    return "€" + str;
  }

  /* ---------- preloader ---------- */
  function initPreloader() {
    var pre = $(".preloader");
    if (!pre) return;
    var seen = false;
    try { seen = sessionStorage.getItem("sabess-preloaded") === "1"; } catch (e) {}
    if (seen) { pre.classList.add("done"); return; }
    var bar = $("b", pre);
    var label = $("span", pre);
    var start = Date.now();
    var timer = setInterval(function () {
      var p = Math.min(100, Math.round((Date.now() - start) / 9));
      if (bar) bar.style.width = p + "%";
      if (label) label.textContent = String(p).padStart(3, "0") + "%";
      if (p >= 100) {
        clearInterval(timer);
        setTimeout(function () {
          pre.classList.add("done");
          try { sessionStorage.setItem("sabess-preloaded", "1"); } catch (e) {}
        }, 250);
      }
    }, 28);
  }

  /* ---------- menu fullscreen ---------- */
  function initMenu() {
    var menu = $(".fullscreen-menu");
    var toggle = $("[data-menu-toggle]");
    if (!menu || !toggle) return;
    var iconOpen = $("[data-icon-open]", toggle);
    var iconClose = $("[data-icon-close]", toggle);

    function setOpen(open) {
      menu.classList.toggle("open", open);
      menu.setAttribute("aria-hidden", open ? "false" : "true");
      toggle.setAttribute("aria-label", open ? "Chiudi menu" : "Apri menu");
      if (iconOpen) iconOpen.hidden = open;
      if (iconClose) iconClose.hidden = !open;
      $$("a, button", menu).forEach(function (el) { el.tabIndex = open ? 0 : -1; });
      if (open) closeCart(true);
      lockScroll();
    }
    on(toggle, "click", function () { setOpen(!menu.classList.contains("open")); });
    $$("a, button", menu).forEach(function (el) {
      el.tabIndex = -1;
      on(el, "click", function () { setOpen(false); });
    });
    window.sabessCloseMenu = function () { setOpen(false); };
  }

  /* ---------- scroll fluido interno ---------- */
  function initSmoothLinks() {
    $$('[data-scroll-to]').forEach(function (el) {
      on(el, "click", function (e) {
        var id = el.getAttribute("data-scroll-to");
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        if (window.sabessCloseMenu) window.sabessCloseMenu();
        setTimeout(function () { target.scrollIntoView({ behavior: "smooth" }); }, 120);
      });
    });
  }

  /* ---------- barra mobile ---------- */
  function initMobileBar() {
    var bar = $(".mobile-bar");
    if (!bar) return;
    var hero = $(".hero");
    function update() {
      var threshold = hero ? window.innerHeight * 0.7 : 200;
      bar.classList.toggle("visible", window.scrollY > threshold);
    }
    update();
    on(window, "scroll", update, { passive: true });
  }

  /* ---------- video in viewport ---------- */
  function initVideos() {
    var clips = $$(".work-clip video");
    if (!clips.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        v.muted = true; v.volume = 0;
        if (entry.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.45 });
    clips.forEach(function (v) { v.muted = true; v.volume = 0; io.observe(v); });
  }

  /* ---------- filtri prodotti ---------- */
  function initFilters() {
    var wrap = $("[data-filters]");
    if (!wrap) return;
    if (!claim(wrap, "data-filters-ready")) return;
    var grid = document.getElementById(wrap.getAttribute("data-filters"));
    if (!grid) return;
    var empty = $("[data-shop-empty]");
    var buttons = $$("button", wrap);
    buttons.forEach(function (btn) {
      on(btn, "click", function () {
        var value = (btn.getAttribute("data-filter") || "").toLowerCase().trim();
        buttons.forEach(function (b) {
          var isOn = b === btn;
          b.classList.toggle("active", isOn);
          b.setAttribute("aria-selected", isOn ? "true" : "false");
        });
        var visible = 0;
        $$(".product-card", grid).forEach(function (card) {
          var haystack = (card.getAttribute("data-cat") || "") + " " +
                         (card.getAttribute("data-tags") || "") + " " +
                         (card.getAttribute("data-collections") || "");
          var show = !value || value === "*" || haystack.toLowerCase().indexOf(value) !== -1;
          card.hidden = !show;
          if (show) visible++;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });
  }

  /* ---------- carrello ---------- */
  var cartPanel, cartLines, cartTotal, cartCheckout;

  function openCart() {
    if (!cartPanel) return;
    if (window.sabessCloseMenu) window.sabessCloseMenu();
    cartPanel.classList.add("open");
    cartPanel.setAttribute("aria-hidden", "false");
    lockScroll();
  }
  function closeCart(silent) {
    if (!cartPanel) return;
    cartPanel.classList.remove("open");
    cartPanel.setAttribute("aria-hidden", "true");
    if (!silent) lockScroll();
  }

  function setCount(n) {
    $$("[data-cart-count]").forEach(function (el) { el.textContent = n; });
  }

  function escapeHtml(v) {
    return String(v == null ? "" : v)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function renderCart(cart) {
    if (!cartLines) return;
    var c = (window.SABESS && window.SABESS.cart) || {};
    setCount(cart.item_count);
    if (cartTotal) cartTotal.innerHTML = formatMoney(cart.total_price);
    if (cartCheckout) cartCheckout.disabled = cart.item_count === 0;

    // barra spedizione gratuita: soglia in euro, valutata sul totale scontato
    var threshold = parseInt(cartPanel.getAttribute("data-free-ship"), 10) || 0;
    var shipFree = threshold > 0 && cart.total_price >= threshold;
    var ship = $("[data-cart-ship]", cartPanel);
    if (ship) {
      if (threshold > 0 && cart.item_count > 0) {
        var missing = Math.max(0, threshold - cart.total_price);
        var txt = $("[data-cart-ship-text]", ship);
        if (txt) {
          txt.textContent = shipFree
            ? (c.shipDone || "")
            : (c.shipTodo || "").replace("{importo}", formatMoney(missing));
        }
        var fill = $("i", ship);
        if (fill) fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + "%";
        ship.classList.toggle("done", shipFree);
        ship.hidden = false;
      } else {
        ship.hidden = true;
      }
    }

    // riepilogo: sconti reali calcolati da Shopify sul carrello
    var recap = $("[data-cart-recap]", cartPanel);
    if (recap) {
      var subEl = $("[data-cart-sub]", cartPanel);
      var dscWrap = $("[data-cart-discounts]", cartPanel);
      var freeShipRow = $("[data-cart-freeship]", cartPanel);
      var original = typeof cart.original_total_price === "number" ? cart.original_total_price : cart.total_price;

      // Gli sconti di riga nel JSON del carrello stanno in "discounts";
      // "line_level_discount_allocations" e' la forma Liquid e puo' mancare.
      // Leggo entrambe, piu' quelli a livello di carrello.
      var byTitle = {};
      var order = [];
      function addDisc(title, amount) {
        if (!amount || amount <= 0) return;
        title = title || "";
        if (!(title in byTitle)) order.push(title);
        byTitle[title] = (byTitle[title] || 0) + amount;
      }
      (cart.items || []).forEach(function (item) {
        var allocs = item.line_level_discount_allocations || item.discounts || [];
        allocs.forEach(function (al) {
          addDisc((al.discount_application && al.discount_application.title) || al.title, al.amount);
        });
      });
      (cart.cart_level_discount_applications || []).forEach(function (ap) {
        addDisc(ap.title, ap.total_allocated_amount);
      });

      // Rete di sicurezza: se Shopify non espone i titoli ma uno sconto c'e',
      // lo mostro comunque ricavando la percentuale dagli importi.
      var totalDisc = typeof cart.total_discount === "number"
        ? cart.total_discount
        : Math.max(0, original - cart.total_price);
      if (!order.length && totalDisc > 0) {
        var pct = original > 0 ? Math.round((totalDisc / original) * 100) : 0;
        addDisc((c.discountLabel || "Sconto [pct]%").replace("[pct]", pct), totalDisc);
      }

      // Prezzo di listino: le confezioni multiple hanno gia lo sconto nel prezzo,
      // quindi il subtotale parte dal pieno e il risparmio si vede come riga a se.
      var listino = 0;
      (cart.items || []).forEach(function (item) {
        var ca = (c.compareAt || {})[String(item.variant_id)];
        var base = (ca && ca > item.original_price) ? ca : item.original_price;
        listino += base * (item.quantity || 0);
      });
      var packSave = Math.max(0, listino - original);
      if (subEl) subEl.textContent = formatMoney(packSave > 0 ? listino : original);
      if (dscWrap) {
        var righe = [];
        if (packSave > 0) {
          righe.push('<div class="cart-recap-row cart-recap-row--save"><span>' +
            escapeHtml(c.packSaveLabel || "Risparmio confezione") +
            "</span><span>\u2212" + formatMoney(packSave) + "</span></div>");
        }
        dscWrap.innerHTML = righe.concat(order.map(function (t) {
          return '<div class="cart-recap-row cart-recap-row--save"><span>' + escapeHtml(t) +
                 "</span><span>\u2212" + formatMoney(byTitle[t]) + "</span></div>";
        })).join("");
      }
      // spedizione: gratis sopra soglia, altrimenti il costo configurato
      var shipCost = shipFree ? 0 : (c.shipCost || 0);
      var shipRow = $("[data-cart-shiprow]", cartPanel);
      var shipValue = $("[data-cart-shipvalue]", cartPanel);
      if (shipValue) shipValue.textContent = shipFree ? (c.shipFreeLabel || "") : formatMoney(shipCost);
      if (shipRow) shipRow.classList.toggle("cart-recap-row--ship", shipFree);
      if (cartTotal) cartTotal.innerHTML = formatMoney(cart.total_price + shipCost);
      recap.hidden = cart.item_count === 0;
    }

    if (typeof window.SABESS._syncSet === "function") window.SABESS._syncSet(cart);

    if (!cart.items.length) {
      cartLines.innerHTML = '<div class="empty-cart"><p>' + (c.empty || "") + "</p></div>";
      return;
    }

    var gruppi = gruppiCarrello(cart);
    cartLines.innerHTML = gruppi.map(function (g) {
      var item = g.items[0];
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : "";
      var pezzi = g.pieces;
      var totale = g.items.reduce(function (t, it) { return t + it.final_line_price; }, 0);
      var variantLabel;
      if (g.bundle) {
        // "2 pezzi", oppure "3 pezzi + 1 pezzo" quando servono due confezioni
        variantLabel = g.items.map(function (it) {
          return (it.quantity > 1 ? it.quantity + " \u00d7 " : "") + it.variant_title;
        }).join(" + ");
      } else {
        variantLabel = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      }
      var many = pezzi > 1;
      var pieces = many && (!g.bundle || g.items.length > 1 || item.quantity > 1)
        ? '<span class="cart-pieces">' + pezzi + " " + (pezzi === 1 ? c.piece : c.pieces) + " " + c.inTotal + "</span>"
        : "";
      var unit = many
        ? '<span class="cart-price-line"><strong>' + formatMoney(Math.round(totale / pezzi)) + "</strong> <small>" + c.each + "</small></span>"
        : "";
      return '' +
        '<div class="cart-line" data-group="' + escapeHtml(g.id) + '" data-pieces="' + pezzi + '">' +
          '<div class="cart-thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") + "</div>" +
          '<div class="cart-line-main">' +
            "<b>" + item.product_title + "</b>" +
            (variantLabel ? '<em class="cart-pack">' + escapeHtml(variantLabel) + "</em>" : "") +
            (subLabel(item) ? '<em class="cart-sub">' + escapeHtml(subLabel(item)) + "</em>" : "") +
            unit + pieces +
            '<div class="quantity">' +
              '<button type="button" data-qty="-1" aria-label="Riduci quantità">' + window.SABESS.icons.minus + "</button>" +
              "<span>" + pezzi + "</span>" +
              '<button type="button" data-qty="1" aria-label="Aumenta quantità">' + window.SABESS.icons.plus + "</button>" +
            "</div>" +
          "</div>" +
          '<div class="cart-line-side">' +
            '<span class="cart-line-total">' + formatMoney(totale) + "</span>" +
            '<button type="button" class="cart-remove" data-remove>' + (c.remove || "") + "</button>" +
          "</div>" +
        "</div>";
    }).join("");
  }

  function fetchCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js", {
      headers: { Accept: "application/json" }
    }).then(function (r) { return r.json(); });
  }

  /* ---------- confezioni nel carrello ----------
     Regola: i pezzi dello stesso prodotto (stesso abbonamento) valgono come
     UNA confezione. 2 pezzi = variante "2 pezzi" (es. 54 €), non 2 x "1 pezzo".
     Il carrello viene sempre riscritto con le varianti reali di Shopify, quindi
     il prezzo che si vede e' esattamente quello del checkout. */
  var cartState = null;          // ultimo carrello letto
  var packCache = {};            // handle -> promessa confezioni
  var cartQueue = Promise.resolve();
  var pezziInAttesa = {};        // gruppo -> pezzi chiesti (click rapidi)
  var operazioniInCorso = 0;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function packSize(title) {
    var m = /(\d+)/.exec(title || "");
    return m ? parseInt(m[1], 10) : 0;
  }

  // Confezioni di un prodotto: [{id, size, price}] solo se TUTTE le varianti
  // hanno un numero di pezzi e ne esiste almeno una da 2+. Altrimenti null.
  function packsFor(handle) {
    if (!handle) return Promise.resolve(null);
    if (!packCache[handle]) {
      packCache[handle] = fetch(rootUrl() + "products/" + encodeURIComponent(handle) + ".js", {
        headers: { Accept: "application/json" }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod || !prod.variants || prod.variants.length < 2) return null;
          var list = [];
          var max = 0;
          for (var i = 0; i < prod.variants.length; i++) {
            var v = prod.variants[i];
            var size = packSize(v.title);
            if (!size) return null;
            if (size > max) max = size;
            list.push({ id: v.id, size: size, price: v.price, available: v.available !== false });
          }
          return max >= 2 ? list : null;
        })
        .catch(function () { delete packCache[handle]; return null; });
    }
    return packCache[handle];
  }

  function loadPacks(cart) {
    var handles = {};
    (cart.items || []).forEach(function (it) { if (it.handle) handles[it.handle] = true; });
    var names = Object.keys(handles);
    return Promise.all(names.map(packsFor)).then(function (res) {
      var map = {};
      names.forEach(function (h, i) { if (res[i]) map[h] = res[i]; });
      cart.__packs = map;
      return cart;
    });
  }

  function planOf(item) {
    var a = item && item.selling_plan_allocation;
    return a && a.selling_plan ? String(a.selling_plan.id) : "";
  }

  function propsOf(item) {
    var p = item && item.properties;
    if (!p || typeof p !== "object") return null;
    var keys = Object.keys(p).filter(function (k) { return p[k] !== null && p[k] !== ""; }).sort();
    if (!keys.length) return null;
    var out = {};
    keys.forEach(function (k) { out[k] = p[k]; });
    return out;
  }

  // Righe raggruppate: un gruppo = stesso prodotto + stesso piano + stesse proprieta'.
  function gruppiCarrello(cart) {
    var packs = cart.__packs || {};
    var byId = {};
    var out = [];
    (cart.items || []).forEach(function (it) {
      var list = packs[it.handle];
      var id;
      if (list) id = "p" + it.product_id + "|" + planOf(it) + "|" + JSON.stringify(propsOf(it) || {});
      else id = "k" + it.key;
      var g = byId[id];
      if (!g) {
        g = byId[id] = { id: id, bundle: !!list, packs: list || null, items: [], pieces: 0 };
        out.push(g);
      }
      g.items.push(it);
      var size = list ? (packSize(it.variant_title) || 1) : 1;
      g.pieces += size * it.quantity;
    });
    // confezione piu' grande per prima: "3 pezzi + 1 pezzo"
    out.forEach(function (g) {
      if (g.bundle) g.items.sort(function (a, b) { return packSize(b.variant_title) - packSize(a.variant_title); });
    });
    return out;
  }

  // Combinazione di confezioni piu' conveniente per n pezzi (a parita' di
  // prezzo, meno confezioni). Restituisce {variantId: quantita} o null.
  function miglioreCombinazione(n, packs) {
    var usabili = packs.filter(function (p) { return p.available; });
    if (!usabili.length || n <= 0) return null;
    var INF = Infinity;
    var cost = [0], cnt = [0], pick = [null];
    for (var i = 1; i <= n; i++) {
      cost[i] = INF; cnt[i] = INF; pick[i] = null;
      for (var j = 0; j < usabili.length; j++) {
        var p = usabili[j];
        if (p.size > i || cost[i - p.size] === INF) continue;
        var c = cost[i - p.size] + p.price;
        var k = cnt[i - p.size] + 1;
        if (c < cost[i] || (c === cost[i] && k < cnt[i])) { cost[i] = c; cnt[i] = k; pick[i] = p; }
      }
    }
    if (cost[n] === INF) return null;
    var res = {};
    for (var r = n; r > 0; r -= pick[r].size) res[pick[r].id] = (res[pick[r].id] || 0) + 1;
    return res;
  }

  function costoAttuale(g) {
    var prezzi = {};
    g.packs.forEach(function (p) { prezzi[p.id] = p.price; });
    return g.items.reduce(function (t, it) {
      return t + (prezzi[it.variant_id] != null ? prezzi[it.variant_id] : it.original_price) * it.quantity;
    }, 0);
  }

  // Porta un gruppo a "pezzi" totali. Restituisce {updates, adds} o null se
  // non c'e' niente da cambiare.
  function pianoGruppo(g, pezzi) {
    var updates = {};
    var adds = [];
    if (pezzi <= 0) {
      g.items.forEach(function (it) { updates[it.key] = 0; });
      return { updates: updates, adds: adds };
    }
    if (!g.bundle) {
      var it0 = g.items[0];
      if (it0.quantity === pezzi) return null;
      updates[it0.key] = pezzi;
      return { updates: updates, adds: adds };
    }
    var target = miglioreCombinazione(pezzi, g.packs);
    if (!target) return null;

    var attuale = {};
    g.items.forEach(function (it) { attuale[it.variant_id] = it.quantity; });
    var uguale = Object.keys(target).length === Object.keys(attuale).length &&
      Object.keys(target).every(function (id) { return attuale[id] === target[id]; });
    if (uguale) return null;
    // se i pezzi non cambiano e la combinazione attuale costa gia' uguale, non tocco nulla
    if (pezzi === g.pieces) {
      var prezzi = {};
      g.packs.forEach(function (p) { prezzi[p.id] = p.price; });
      var costoTarget = Object.keys(target).reduce(function (t, id) { return t + prezzi[id] * target[id]; }, 0);
      if (costoAttuale(g) <= costoTarget) return null;
    }

    var modello = g.items[0];
    var piano = planOf(modello);
    var props = propsOf(modello);
    g.items.forEach(function (it) {
      var q = target[it.variant_id] || 0;
      if (q !== it.quantity) updates[it.key] = q;
    });
    Object.keys(target).forEach(function (id) {
      if (attuale[id]) return;
      var add = { id: Number(id), quantity: target[id] };
      if (piano) add.selling_plan = Number(piano);
      if (props) add.properties = props;
      adds.push(add);
    });
    return { updates: updates, adds: adds };
  }

  function postJson(url, data) {
    return fetch(rootUrl() + url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || "Errore");
        return d;
      });
    });
  }

  // Applica i piani: PRIMA aggiungo le confezioni nuove, POI tolgo/riduco le
  // vecchie. Se l'aggiunta fallisce il carrello resta com'era (nessun pezzo perso).
  function applicaPiani(piani) {
    var adds = [];
    var updates = {};
    piani.forEach(function (p) {
      if (!p) return;
      adds = adds.concat(p.adds);
      Object.keys(p.updates).forEach(function (k) { updates[k] = p.updates[k]; });
    });
    var passo = Promise.resolve();
    if (adds.length) passo = passo.then(function () { return postJson("cart/add.js", { items: adds }); });
    if (Object.keys(updates).length) passo = passo.then(function () { return postJson("cart/update.js", { updates: updates }); });
    return passo;
  }

  function firma(cart) {
    return (cart.items || []).map(function (it) { return it.key + "x" + it.quantity; }).join(",");
  }

  // Legge il carrello e, se serve, lo riscrive in confezioni. Un giro solo:
  // dopo la riscrittura il carrello e' gia' nella forma giusta.
  function normalizza(cart) {
    return loadPacks(cart).then(function (c1) {
      var piani = gruppiCarrello(c1)
        .filter(function (g) { return g.bundle; })
        .map(function (g) { return pianoGruppo(g, g.pieces); })
        .filter(Boolean);
      if (!piani.length) return c1;
      var prima = firma(c1);
      return applicaPiani(piani)
        .catch(function (err) { if (window.console) console.warn("[sabess] confezioni", err); })
        .then(fetchCart)
        .then(loadPacks)
        .then(function (c2) { c2.__changed = firma(c2) !== prima; return c2; });
    });
  }

  // Tutte le operazioni sul carrello passano da qui, una alla volta.
  function inCoda(fn) {
    var run = cartQueue.then(fn, fn);
    cartQueue = run.catch(function () {});
    return run;
  }

  function syncCart() {
    return inCoda(function () {
      if (cartPanel) cartPanel.classList.add("busy");
      return fetchCart()
        .then(normalizza)
        .then(function (cart) { cartState = cart; renderCart(cart); aggiornaPaginaCarrello(cart); return cart; })
        .finally(function () { if (cartPanel) cartPanel.classList.remove("busy"); });
    });
  }

  // Cambia i pezzi totali di un gruppo (bottoni +/- e Rimuovi).
  function setPezzi(groupId, pezzi) {
    return inCoda(function () {
      if (cartPanel) cartPanel.classList.add("busy");
      return fetchCart().then(loadPacks)
        .then(function (cart) {
          var g = gruppiCarrello(cart).filter(function (x) { return x.id === groupId; })[0];
          if (!g) return null;
          var piano = pianoGruppo(g, Math.max(0, pezzi));
          if (!piano) return null;
          return applicaPiani([piano]).catch(function (err) { showToast(err.message || "Errore"); });
        })
        .then(fetchCart)
        .then(normalizza)
        .then(function (cart) { cartState = cart; renderCart(cart); aggiornaPaginaCarrello(cart, true); return cart; })
        .finally(function () { if (cartPanel) cartPanel.classList.remove("busy"); });
    });
  }

  // Compatibilita': cambia una singola riga per chiave.
  function changeLine(key, quantity) {
    return inCoda(function () {
      var u = {}; u[key] = quantity;
      return postJson("cart/update.js", { updates: u });
    }).then(syncCart);
  }

  // Pagina /cart (Liquid): se il carrello e' stato riscritto, ricarico per
  // mostrare righe e totali aggiornati da Shopify.
  function aggiornaPaginaCarrello(cart, force) {
    if (!document.querySelector(".cart-page")) return;
    if (force || (cart && cart.__changed)) window.location.reload();
  }

  function showToast(text) {
    var toast = $(".toast");
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add("show");
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove("show"); }, 2200);
  }

  // Testo dell'abbonamento su una riga del carrello. Uso l'etichetta impostata
  // nel tema; se e' vuota ricado sul nome del piano, che e' lo stesso che il
  // cliente rivede al checkout.
  function subLabel(item) {
    var all = item && item.selling_plan_allocation;
    if (!all) return "";
    var cfg = (window.SABESS && window.SABESS.cart) || {};
    if (cfg.subLabel) return cfg.subLabel;
    return (all.selling_plan && all.selling_plan.name) || "";
  }

  function addItemsToCart(items, openAfter) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || err.message || "Errore"); });
        return r.json();
      })
      .then(function () { return syncCart(); })
      .then(function (cart) {
        if (navigator.vibrate) navigator.vibrate(20);
        if (openAfter !== false) setTimeout(openCart, 150);
        return cart;
      })
      .catch(function (err) { showToast(err.message || "Errore"); });
  }

  function addToCart(variantId, quantity, openAfter, sellingPlan) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [sellingPlan
        ? { id: Number(variantId), quantity: Number(quantity) || 1, selling_plan: Number(sellingPlan) }
        : { id: Number(variantId), quantity: Number(quantity) || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || err.message || "Errore"); });
        return r.json();
      })
      .then(function () { return syncCart(); })
      .then(function (cart) {
        if (navigator.vibrate) navigator.vibrate(20);
        if (openAfter !== false) setTimeout(openCart, 150);
        return cart;
      })
      .catch(function (err) { showToast(err.message || "Errore"); });
  }

  function initCart() {
    cartPanel = $(".cart-panel");
    if (!cartPanel) return;
    if (!claim(cartPanel, "data-cart-ready")) return;
    cartLines = $(".cart-lines", cartPanel);
    cartTotal = $("[data-cart-total]", cartPanel);
    cartCheckout = $("[data-cart-checkout]", cartPanel);

    $$("[data-cart-open]").forEach(function (el) {
      on(el, "click", function (e) { e.preventDefault(); openCart(); });
    });
    $$("[data-cart-close]", cartPanel).forEach(function (el) { on(el, "click", function () { closeCart(); }); });

    on(cartLines, "click", function (e) {
      var remove = e.target.closest("[data-remove]");
      if (remove) {
        var rLine = remove.closest(".cart-line");
        if (rLine) setPezzi(rLine.getAttribute("data-group"), 0);
        return;
      }
      var btn = e.target.closest("[data-qty]");
      if (!btn) return;
      var line = btn.closest(".cart-line");
      if (!line) return;
      // click rapidi: parto dall'ultimo valore chiesto, non da quello ancora a schermo
      var gid = line.getAttribute("data-group");
      var current = gid in pezziInAttesa ? pezziInAttesa[gid] : (parseInt(line.getAttribute("data-pieces"), 10) || 0);
      var next = Math.max(0, current + parseInt(btn.getAttribute("data-qty"), 10));
      pezziInAttesa[gid] = next;
      var span = line.querySelector(".quantity span");
      if (span) span.textContent = next;
      operazioniInCorso++;
      setPezzi(gid, next).finally(function () {
        operazioniInCorso--;
        if (!operazioniInCorso) pezziInAttesa = {};
      });
    });

    // pagina /cart: i +/- lavorano sui pezzi del prodotto, come nel carrello a scomparsa
    var pagina = document.querySelector(".cart-page");
    if (pagina) {
      on(pagina, "click", function (e) {
        var a = e.target.closest("[data-page-qty]");
        if (!a) return;
        var riga = a.closest("[data-key]");
        if (!riga) return;
        e.preventDefault();
        var delta = parseInt(a.getAttribute("data-page-qty"), 10) || 0;
        var key = riga.getAttribute("data-key");
        var base = cartState ? Promise.resolve(cartState) : fetchCart().then(loadPacks);
        base.then(function (cart) {
          var g = gruppiCarrello(cart).filter(function (x) {
            return x.items.some(function (it) { return it.key === key; });
          })[0];
          if (g) setPezzi(g.id, g.pieces + delta);
        });
      });
    }

    on(document, "keydown", function (e) {
      if (e.key === "Escape") { closeCart(); if (window.sabessCloseMenu) window.sabessCloseMenu(); }
    });

    syncCart();

    // pulsanti "Aggiungi" sulle card e sui prodotti correlati
    $$("[data-add-to-cart]").forEach(function (btn) {
      on(btn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute("data-add-to-cart");
        if (!id) { window.location.href = btn.getAttribute("data-url") || "/"; return; }
        btn.disabled = true;
        addToCart(id, btn.getAttribute("data-quantity") || 1, btn.getAttribute("data-open") !== "false",
          (btn.closest("[data-product-form]") || {}).__sabessPlan ? btn.closest("[data-product-form]").__sabessPlan() : "")
          .then(function () {
            btn.classList.add("added");
            setTimeout(function () { btn.classList.remove("added"); }, 1600);
          })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------- PDP: selettore confezioni + galleria ---------- */
  function initProductPage() {
    var form = $("[data-product-form]");
    if (!form) return;
    if (!claim(form, "data-pdp-ready")) return;
    var idInput = $("[data-variant-id]", form);
    var priceEl = $("[data-variant-price]");
    var comparEl = $("[data-variant-compare]");
    var selectedEl = $("[data-variant-label]");
    var submit = $("[data-product-submit]");
    var bundles = $$("[data-variant]");

    function select(btn) {
      bundles.forEach(function (b) { b.classList.toggle("on", b === btn); });
      if (idInput) {
        idInput.value = btn.getAttribute("data-variant");
        // Il selettore confezioni e del tema, non un menu Shopify standard: le app
        // esterne (abbonamenti) non se ne accorgerebbero. Le avviso esplicitamente.
        try {
          idInput.dispatchEvent(new Event("change", { bubbles: true }));
          document.dispatchEvent(new CustomEvent("variant:change", {
            detail: { id: idInput.value }, bubbles: true
          }));
        } catch (e) {}
      }
      if (priceEl) { priceEl.innerHTML = btn.getAttribute("data-price"); priceEl.removeAttribute("data-shown"); }
      if (comparEl) {
        var c = btn.getAttribute("data-compare");
        comparEl.innerHTML = c || "";
        comparEl.hidden = !c;
      }
      if (selectedEl) selectedEl.textContent = btn.getAttribute("data-label") || "";
      var available = btn.getAttribute("data-available") === "true";
      if (submit) {
        submit.disabled = !available;
        var lbl = submit.querySelector("[data-submit-label]");
        if (lbl) {
          lbl.textContent = available
            ? (submit.getAttribute("data-label-add") || window.SABESS.t.addToCart)
            : (submit.getAttribute("data-label-sold") || window.SABESS.t.soldOut);
        }
      }
      // stato in URL, così tornando indietro la selezione resta (fix bfcache)
      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", btn.getAttribute("data-variant"));
        history.replaceState({ variant: btn.getAttribute("data-variant") }, "", url.toString());
      } catch (e) {}
    }

    // Abbonamenti: il piano lo imposta l'app nel campo selling_plan del form.
    // Lo rileggo sempre al momento dell'aggiunta, così non si perde mai.
    var planPrices = {};
    try {
      var planTag = $("[data-selling-plans]");
      if (planTag) planPrices = JSON.parse(planTag.textContent || "{}");
    } catch (e) {}

    function currentPlan() {
      // L'app degli abbonamenti puo mettere il campo fuori dal form, e puo essere
      // un gruppo di radio: prendo il primo davvero selezionato, ovunque si trovi.
      var els = form.querySelectorAll('[name="selling_plan"]');
      if (!els.length) els = document.querySelectorAll('[name="selling_plan"]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.type === "checkbox" || el.type === "radio") {
          if (el.checked && el.value) return el.value;
        } else if (el.value) return el.value;
      }
      return "";
    }
    form.__sabessPlan = currentPlan;

    // Prezzo mostrato = prezzo della confezione, con lo sconto abbonamento se
    // attivo. Vale per il prezzo grande E per tutti i riquadri, cosi' i numeri
    // sono sempre gli stessi che Shopify usera' al checkout.
    function prezziDi(btn, plan) {
      var base = parseInt(btn.getAttribute("data-base"), 10) || 0;
      var list = parseInt(btn.getAttribute("data-list"), 10) || base;
      var perVar = planPrices[String(btn.getAttribute("data-variant"))] || {};
      var sub = plan ? perVar[String(plan)] : null;
      var price = (typeof sub === "number" && sub > 0) ? sub : base;
      return {
        base: base,
        price: price,
        subbed: price < base,
        // prezzo barrato: con abbonamento il prezzo della confezione (es. 54),
        // senza abbonamento il listino se la confezione e' scontata (es. 60)
        compare: price < base ? base : (list > base ? list : 0),
        save: Math.max(0, list - price)
      };
    }

    function flash(el) {
      if (!el) return;
      el.classList.remove("flash");
      void el.offsetWidth;
      el.classList.add("flash");
    }

    function refreshPrice() {
      if (!idInput) return;
      var plan = currentPlan();

      bundles.forEach(function (b) {
        var pr = prezziDi(b, plan);
        var stato = pr.price + "|" + pr.subbed;
        if (b.getAttribute("data-shown") === stato) return;
        var primo = !b.hasAttribute("data-shown");
        b.setAttribute("data-shown", stato);
        var strong = b.querySelector("[data-bundle-price]") || b.querySelector("strong");
        if (strong) {
          strong.innerHTML = formatMoney(pr.price) + (pr.subbed ? " <s>" + formatMoney(pr.base) + "</s>" : "");
          if (!primo) flash(strong);
        }
        var small = b.querySelector("[data-bundle-save]");
        if (small) {
          if (pr.save > 0) {
            small.textContent = (small.getAttribute("data-save-label") || "Risparmi") + " " + formatMoney(pr.save);
            small.hidden = false;
          } else {
            small.textContent = "";
            small.hidden = true;
          }
        }
      });

      if (!priceEl) return;
      var attivo = bundles.filter(function (b) { return b.classList.contains("on"); })[0];
      var top;
      if (attivo) top = prezziDi(attivo, plan);
      else {
        var perVar = planPrices[String(idInput.value)] || {};
        var sp = plan && perVar[String(plan)];
        top = sp ? { price: sp, compare: 0, subbed: true } : null;
      }
      if (!top) return;
      var statoTop = idInput.value + "|" + top.price + "|" + top.compare;
      // Il prezzo sta dentro il form osservato: scrivo solo se cambia davvero,
      // altrimenti l'osservatore si riattiverebbe da solo all'infinito.
      if (priceEl.getAttribute("data-shown") === statoTop) return;
      var primoTop = !priceEl.hasAttribute("data-shown");
      priceEl.setAttribute("data-shown", statoTop);
      priceEl.innerHTML = formatMoney(top.price);
      if (comparEl) {
        comparEl.innerHTML = top.compare ? formatMoney(top.compare) : "";
        comparEl.hidden = !top.compare;
      }
      if (!primoTop) flash(priceEl.parentNode);
    }
    on(document, "change", refreshPrice);
    on(document, "input", refreshPrice);
    if (window.MutationObserver) {
      var opz = { subtree: true, childList: true, attributes: true, attributeFilter: ["value", "checked", "class"] };
      // Molte app scrivono il piano con JavaScript (input.value = "..."), che NON
      // modifica l'attributo e quindi non fa scattare nessun osservatore.
      // Controllo a intervalli: e l'unico modo affidabile di accorgersene.
      var ultimoPiano = currentPlan();
      setInterval(function () {
        var ora = currentPlan();
        if (ora !== ultimoPiano) { ultimoPiano = ora; refreshPrice(); }
      }, 500);
      new window.MutationObserver(refreshPrice).observe(form, opz);
      if (!form.querySelector('[name="selling_plan"]')) {
        new window.MutationObserver(refreshPrice).observe(document.body, opz);
      }
    }

    // Selettore abbonamento del tema: scrive nel campo standard selling_plan,
    // che e' anche cio' che leggono currentPlan() e l'aggiunta al carrello.
    var subWrap = $("[data-pdp-sub]");
    if (subWrap) {
      var subToggle = $("[data-sub-toggle]", subWrap);
      var subSelect = $("[data-sub-plan]", subWrap);
      var subBadge = $("[data-sub-badge]", subWrap);
      var planInput = form.querySelector('[name="selling_plan"]');

      function subBase() {
        var attivo = bundles.filter(function (b) { return b.classList.contains("on"); })[0];
        return attivo ? parseInt(attivo.getAttribute("data-base"), 10) || 0 : 0;
      }
      function aggiornaBadge() {
        if (!subBadge || !subSelect || !idInput) return;
        var perVar = planPrices[String(idInput.value)] || {};
        var p = perVar[String(subSelect.value)];
        var base = subBase();
        if (p && base > 0 && p < base) {
          subBadge.textContent = "-" + Math.round((base - p) * 100 / base) + "%";
          subBadge.hidden = false;
        } else subBadge.hidden = true;
      }
      function applicaSub() {
        var val = subToggle && subToggle.checked && subSelect ? subSelect.value : "";
        if (planInput) planInput.value = val;
        subWrap.classList.toggle("on", !!val);
        aggiornaBadge();
        refreshPrice();
      }
      on(subToggle, "change", applicaSub);
      on(subSelect, "change", applicaSub);
      form.__sabessSubSync = function () { aggiornaBadge(); };
      aggiornaBadge();
    }

    bundles.forEach(function (btn) { on(btn, "click", function () { select(btn); refreshPrice(); if (form.__sabessSubSync) form.__sabessSubSync(); }); });

    // inizializzazione: variante da URL, altrimenti la prima disponibile.
    // La quantità parte SEMPRE da 1.
    function initSelection() {
      var params = new URLSearchParams(window.location.search);
      var wanted = params.get("variant");
      var match = wanted ? bundles.filter(function (b) { return b.getAttribute("data-variant") === wanted; })[0] : null;
      var target = match || bundles.filter(function (b) { return b.getAttribute("data-available") === "true"; })[0] || bundles[0];
      if (target) select(target);
      var qty = $("[data-product-qty]", form);
      if (qty) qty.value = 1;
    }
    initSelection();

    // ripristino da bfcache: reinizializza lo stato invece di lasciarlo vuoto
    on(window, "pageshow", function (event) { if (event.persisted) initSelection(); });

    on(form, "submit", function (e) {
      e.preventDefault();
      if (!idInput || !idInput.value) return;
      if (submit) submit.disabled = true;
      // Mando al carrello TUTTO il contenuto del form, non un elenco deciso da me:
      // cosi' qualunque campo aggiunto da un'app (piano di abbonamento, proprieta'
      // di riga, opzioni regalo) arriva a Shopify senza che io debba conoscerlo.
      var dati;
      try { dati = new FormData(form); } catch (e2) { dati = null; }
      var item = { id: Number(idInput.value), quantity: 1 };
      if (dati) {
        var q = Number(dati.get("quantity"));
        if (q > 0) item.quantity = q;
        var piano = dati.get("selling_plan") || currentPlan();
        if (piano) item.selling_plan = Number(piano);
        dati.forEach(function (val, chiave) {
          var m = /^properties\[(.+)\]$/.exec(chiave);
          if (m && val !== "" && val != null) {
            item.properties = item.properties || {};
            item.properties[m[1]] = val;
          }
        });
      } else {
        var p2 = currentPlan();
        if (p2) item.selling_plan = Number(p2);
      }
      addItemsToCart([item], true).finally(function () { if (submit) submit.disabled = false; });
    });

    // galleria
    var shots = $$(".pdp-shot");
    $$(".pdp-thumbs button").forEach(function (thumb, i) {
      on(thumb, "click", function () {
        $$(".pdp-thumbs button").forEach(function (t) { t.classList.remove("on"); });
        thumb.classList.add("on");
        shots.forEach(function (s, j) { s.classList.toggle("on", i === j); });
      });
    });
  }


  /* ---------- crea il tuo set ---------- */
  function initSetBuilder() {
    var wrap = $("[data-set-builder]");
    if (!wrap) return;
    if (!claim(wrap, "data-setb-ready")) return;

    var freeShip = parseInt(wrap.getAttribute("data-free-ship"), 10) || 0;
    var shipCost = parseInt(wrap.getAttribute("data-ship-cost"), 10) || 0;
    // varianti gia' finite nel carrello: servono per rispecchiare le rimozioni
    var committed = Object.create(null);
    var tiers = [];
    try { tiers = JSON.parse(wrap.getAttribute("data-tiers") || "[]"); } catch (e) { tiers = []; }
    // solo scaglioni validi, ordinati per quantita crescente
    tiers = tiers.filter(function (t) { return t && t.qty > 0 && t.pct > 0; })
                 .sort(function (a, b) { return a.qty - b.qty; });

    var cards = $$("[data-setb-card]", wrap);
    var bar = $("[data-setb-bar] i", wrap);
    var barWrap = $("[data-setb-bar]", wrap);
    var countEl = $("[data-setb-count]", wrap);
    var stickyCount = $("[data-setb-sticky-count]");
    var noteEl = $("[data-setb-note]");
    var submit = $("[data-setb-submit]");
    var submitLabel = $("[data-setb-submit-label]");
    var recap = $("[data-setb-recap]", wrap);
    var subEl = $("[data-setb-sub]", wrap);
    var saveRow = $("[data-setb-save-row]", wrap);
    var saveEl = $("[data-setb-save]", wrap);
    var saveLabelEl = $("[data-setb-save-label]", wrap);
    var shipRow = $("[data-setb-ship-row]", wrap);
    var totalEl = $("[data-setb-total]", wrap);
    var cfg = window.SABESS.setb || {};

    var minQty = tiers.length ? tiers[0].qty : 0;
    var maxQty = tiers.length ? tiers[tiers.length - 1].qty : 0;

    function selected() {
      return cards.filter(function (c) { return c.classList.contains("on"); });
    }

    // lo scaglione piu alto raggiunto da n prodotti
    function tierFor(n) {
      var hit = null;
      for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].qty) hit = tiers[i];
      return hit;
    }
    function nextTier(n) {
      for (var i = 0; i < tiers.length; i++) if (n < tiers[i].qty) return tiers[i];
      return null;
    }

    function update() {
      var sel = selected();
      var n = sel.length;
      var sub = sel.reduce(function (sum, c) { return sum + (parseInt(c.getAttribute("data-price"), 10) || 0); }, 0);
      var word = n === 1 ? cfg.product : cfg.products;

      var tier = tierFor(n);
      var next = nextTier(n);
      var pct = tier ? tier.pct : 0;
      var save = Math.round(sub * pct / 100);
      var total = sub - save;

      if (countEl) countEl.textContent = n + " " + word + " · " + formatMoney(sub);
      if (stickyCount) stickyCount.textContent = n + " " + word + " " + cfg.inSet;

      // barra: avanzamento verso lo scaglione massimo
      if (bar) {
        var pctBar = maxQty > 0 ? Math.min(100, (n / maxQty) * 100) : (n ? 100 : 0);
        bar.style.width = pctBar + "%";
        if (barWrap) barWrap.setAttribute("aria-valuenow", Math.round(pctBar));
      }

      // si accende solo lo scaglione in cui ci si trova, non quelli superati
      tiers.forEach(function (t, i) {
        var li = $('[data-tier="' + (i + 1) + '"]', wrap);
        if (li) li.classList.toggle("on", t === tier);
      });

      // riepilogo
      if (recap) recap.hidden = n === 0;
      if (subEl) subEl.textContent = formatMoney(sub);
      if (saveRow) saveRow.hidden = save <= 0;
      if (saveEl) saveEl.textContent = "−" + formatMoney(save);
      if (saveLabelEl) saveLabelEl.textContent = (cfg.saveLbl || "").replace("[pct]", pct);
      var shipFree = freeShip > 0 && total >= freeShip;
      var ship = shipFree ? 0 : shipCost;
      var shipValueEl = $("[data-setb-ship-value]", wrap);
      if (shipValueEl) shipValueEl.textContent = shipFree ? (cfg.shipFreeLabel || "") : formatMoney(ship);
      if (shipRow) shipRow.classList.toggle("setb-recap-row--ship", shipFree);
      if (totalEl) totalEl.textContent = formatMoney(total + ship);

      var note;
      if (!n) note = cfg.noteEmpty;
      else if (next) {
        var missing = next.qty - n;
        note = (cfg.noteNext || "")
          .replace("{n}", missing)
          .replace("{parola}", missing === 1 ? cfg.product : cfg.products)
          .replace("[pct]", next.pct);
      } else note = cfg.noteDone;
      if (noteEl) noteEl.textContent = note;

      if (submit) submit.disabled = n === 0;
      if (submitLabel) submitLabel.textContent = n ? cfg.submit + " · " + formatMoney(total + ship) : cfg.submit;
    }

    cards.forEach(function (card) {
      var btn = $("[data-setb-toggle]", card);
      if (!btn) return;
      on(btn, "click", function () {
        var isOn = card.classList.toggle("on");
        btn.classList.toggle("on", isOn);
        btn.setAttribute("aria-pressed", isOn ? "true" : "false");
        update();
      });
    });

    if (submit) {
      on(submit, "click", function () {
        var sel = selected();
        var items = sel.map(function (c) {
          return { id: Number(c.getAttribute("data-variant")), quantity: 1 };
        });
        if (!items.length) return;
        submit.disabled = true;

        items.forEach(function (it) { committed[it.id] = true; });
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || "Errore"); });
            return r.json();
          })
          .then(function () {
            // Lo sconto e la spedizione li applica Shopify da solo:
            // basta rileggere il carrello (riscritto in confezioni) e mostrarlo.
            return syncCart();
          })
          .then(function (cart) {
            if (!cart) return;
            if (navigator.vibrate) navigator.vibrate(20);
            setTimeout(openCart, 150);
          })
          .catch(function (e) { showToast(e.message || "Errore"); })
          .finally(function () { submit.disabled = false; });
      });
    }

    // se una variante gia' aggiunta sparisce dal carrello, la card torna deselezionata
    window.SABESS._syncSet = function (cart) {
      var inCart = Object.create(null);
      (cart && cart.items ? cart.items : []).forEach(function (it) {
        inCart[it.variant_id] = true;
        inCart[it.id] = true;
        // la variante singola puo' essere stata unita in una confezione dello stesso prodotto
        inCart["p" + it.product_id] = true;
      });
      var changed = false;
      cards.forEach(function (card) {
        var id = Number(card.getAttribute("data-variant"));
        if (!committed[id] || inCart[id] || inCart["p" + card.getAttribute("data-product")]) return;
        delete committed[id];
        if (!card.classList.contains("on")) return;
        card.classList.remove("on");
        var btn = $("[data-setb-toggle]", card);
        if (btn) { btn.classList.remove("on"); btn.setAttribute("aria-pressed", "false"); }
        changed = true;
      });
      if (changed) update();
    };

    update();
  }

  /* ---------- timeline storia ---------- */
  function initTimeline() {
    // barra verticale che si riempie mentre si scorre
    var tl = $(".tl");
    var rail = $(".tl-rail i");
    if (tl && rail) {
      var updateRail = function () {
        var rect = tl.getBoundingClientRect();
        var span = rect.height - window.innerHeight * 0.5;
        var ratio = span > 0 ? (window.innerHeight * 0.75 - rect.top) / span : 1;
        rail.style.height = Math.max(0, Math.min(1, ratio)) * 100 + "%";
      };
      updateRail();
      on(window, "scroll", updateRail, { passive: true });
      on(window, "resize", updateRail);
    }

    // capitoli che entrano in scena
    var chapters = $$(".story-chapter");
    if (chapters.length) {
      if ("IntersectionObserver" in window) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); cio.unobserve(e.target); } });
        }, { threshold: 0.15 });
        chapters.forEach(function (c) { cio.observe(c); });
      } else {
        chapters.forEach(function (c) { c.classList.add("in"); });
      }
    }

    var stops = $$(".tl-stop");
    if (!stops.length || !("IntersectionObserver" in window)) { stops.forEach(function (s) { s.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) entry.target.classList.add("in"); });
    }, { threshold: 0.3 });
    stops.forEach(function (s) { io.observe(s); });
  }

  // Il Theme Editor rilancia init() a ogni "shopify:section:load".
  // Senza questo, i listener si sommano e le closure si sdoppiano.
  function claim(el, key) {
    if (!el || el.getAttribute(key)) return false;
    el.setAttribute(key, "1");
    return true;
  }

  /* ---------- avvio ---------- */
  function init() {
    var steps = [initPreloader, initMenu, initSmoothLinks, initMobileBar, initVideos,
                 initFilters, initCart, initProductPage, initSetBuilder, initTimeline];
    steps.forEach(function (fn) {
      try { fn(); } catch (err) { if (window.console) console.error("[sabess]", fn.name, err); }
    });
  }

  if (document.readyState === "loading") on(document, "DOMContentLoaded", init);
  else init();

  // Ricarica lo stato quando la pagina torna dalla bfcache
  on(window, "pageshow", function (event) {
    if (event.persisted) { syncCart(); lockScroll(); }
  });

  // API pubblica per il Theme Editor
  document.addEventListener("shopify:section:load", init);
})();

/* Il footer non deve mai finire sotto le barre fisse in basso.
   Misuro quanto spazio occupano davvero dal bordo inferiore della finestra. */
(function () {
  if (window.__sabessBarPad) return;
  window.__sabessBarPad = true;

  var SEL = ".setb-sticky, .mobile-bar";
  var osservate = [];

  function spazio(el) {
    var cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return 0;
    if (el.classList.contains("mobile-bar") && !el.classList.contains("visible")) return 0;
    var r = el.getBoundingClientRect();
    if (!r.height) return 0;
    return Math.max(0, Math.round(window.innerHeight - r.top));
  }

  function applica() {
    var max = 0;
    document.querySelectorAll(SEL).forEach(function (el) {
      var v = spazio(el);
      if (v > max) max = v;
    });
    if (max > 0) document.documentElement.style.setProperty("--bottom-bar-h", max + "px");
    else document.documentElement.style.removeProperty("--bottom-bar-h");
  }

  function osserva() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (osservate.indexOf(el) > -1) return;
      osservate.push(el);
      if (window.ResizeObserver) new ResizeObserver(applica).observe(el);
      if (window.MutationObserver) new MutationObserver(applica).observe(el, { attributes: true, attributeFilter: ["class", "style"], childList: true, subtree: true });
    });
    applica();
  }

  window.SABESS = window.SABESS || {};
  window.SABESS._padBars = osserva;

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", osserva);
  else osserva();
  window.addEventListener("resize", applica);
  window.addEventListener("orientationchange", applica);
  document.addEventListener("shopify:section:load", osserva);
})();
